import "../App.css";
function TopHeader() {
  return (
    <div className="bg-[#2f2f2f] w-full text-white h-10 mt-[0.5px] pt-[9px] text-sm overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap">
        <span className="mx-8">
          <pre>
            CALL US AT UAN: 042-111-000-786 FOR INTERNATIONAL WEBSITE VISIT
            BAROQUE.VERCEL.APP
          </pre>
        </span>
        <span className="mx-8">
          <pre>
            CALL US AT UAN: 042-111-000-786 FOR INTERNATIONAL WEBSITE VISIT
            BAROQUE.VERCEL.APP
          </pre>
        </span>
        <span className="mx-8">
          <pre>
            CALL US AT UAN: 042-111-000-786 FOR INTERNATIONAL WEBSITE VISIT
            BAROQUE.VERCEL.APP
          </pre>
        </span>
        <span className="mx-8">
          <pre>
            CALL US AT UAN: 042-111-000-786 FOR INTERNATIONAL WEBSITE VISIT
            BAROQUE.VERCEL.APP
          </pre>
        </span>
        <span className="mx-8">
          <pre>
            CALL US AT UAN: 042-111-000-786 FOR INTERNATIONAL WEBSITE VISIT
            BAROQUE.VERCEL.APP
          </pre>
        </span>
        <span className="mx-8">
          <pre>
            CALL US AT UAN: 042-111-000-786 FOR INTERNATIONAL WEBSITE VISIT
            BAROQUE.VERCEL.APP
          </pre>
        </span>
      </div>
    </div>
  );
}

export default TopHeader;
